module.exports = __webpack_public_path__ + "static/media/jars.32c512af.png";